import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';

export const validarSenha =
  (senhaControl: string, confirmarSenhaControl: string): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    if (!(control instanceof FormGroup)) {
      throw new Error('validarSenha deve ser usado no FormGroup');
    }

    const senha = control.controls[senhaControl].value;
    const confirmarSenha = control.controls[confirmarSenhaControl].value;
    const isLengthValidFunc = senha.length >= 8;
    const hasNumberFunc = /\d/.test(senha);
    const hasLowercaseFunc = /[a-z]/.test(senha);
    const hasUppercaseFunc = /[A-Z]/.test(senha);
    const hasSpecialCharFunc = /[!@#$%^&*(),.?":{}|<>]/.test(senha);
    const passwordsMatchFunc = senha === confirmarSenha;
    const isValidFunc =
      isLengthValidFunc &&
      hasNumberFunc &&
      hasLowercaseFunc &&
      hasUppercaseFunc &&
      hasSpecialCharFunc &&
      passwordsMatchFunc;

    if (!isValidFunc) {
      return {
        isLengthValidFunc,
        hasNumberFunc,
        hasLowercaseFunc,
        hasUppercaseFunc,
        hasSpecialCharFunc,
        passwordsMatchFunc,
        isValidFunc
      };
    }

    return null;
  };
